import styled from 'styled-components'
import { icons } from 'utils/icons'

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #e1f5fe;
`

const Content = styled.div`
  text-align: center;

  padding: 40px;
  border-radius: 10px;

  max-width: 400px;
  width: 100%;
`

const Logo = styled.div`
  margin-bottom: 20px;
`

const Title = styled.h1`
  font-size: 2rem;
  color: #0c9eda;
  margin: 20px 0;
`

const Paragraph = styled.p`
  font-size: 1rem;
  color: #555;
  margin-bottom: 20px;
`

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: 10px;
`

const Button = styled.button`
  background-color: #0c9eda;
  color: white;
  border-radius: 20px;
  cursor: pointer;
  width: 50%;
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background-color: #53c0a8;
  }
`

const ButtonImage = styled.img`
  width: 40px; // Adjust the size of the images
  margin-right: 10px; // Space between the image and text
`

function MobileRedirect() {
  return (
    <Container>
      <Content>
        <Logo>
          <img src={`${icons.mobileIcon.src}`} alt="Vimesoft Logo" width="300" />
        </Logo>
        <Title>
          <img src={`${icons.vimeLogo.src}`} alt="Vimesoft Logo" width="300" />
        </Title>
        <Paragraph>
          Platformumuza mobil uygulamamızla kolayca erişebilirsiniz. Uygulamamızı hemen indirip
          kullanmaya başlayın!
        </Paragraph>

        <ButtonWrapper>
          <Button
            onClick={() =>
              (window.location.href =
                'https://play.google.com/store/apps/details?id=com.vimesoft.space')
            }
          >
            <ButtonImage src={`${icons.playstore.src}`} alt="Play Store" />
            Google Play
          </Button>
          <Button
            onClick={() =>
              (window.location.href = 'https://apps.apple.com/tr/app/vimesoft-kurumsal-mesajla%C5%9Fma/id6471935548?l=tr')
            }
          >
            <ButtonImage src={`${icons.appstore.src}`} alt="App Store" />
            App Store
          </Button>
        </ButtonWrapper>
      </Content>
    </Container>
  )
}

export default MobileRedirect
